module.exports = __webpack_public_path__ + "img/pencil-draw.bc75ed96.svg";